module.exports = __webpack_public_path__ + "img/ic_chevron_open_tab.62a8fae7.svg";